/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useMemo, useContext } from 'react';
import { urlQueryString } from '@azgaz/azgaz-ui/connect/lib/utils';
import { RangeSlider } from '@azgaz/azgaz-ui';
import { AppContext } from '@/apps/context';

type PriceSliderProps = React.ComponentProps<typeof RangeSlider> & {
  isRange: boolean;
  // eslint-disable-next-line react/require-default-props
  value?: [number, number];
  touched: boolean;
  changeTouched: (v: boolean) => void;
};

const STEP = 1000;

const round = (a: number, b: number) => {
  if (a % b === 0) return a;
  return Math.trunc(a / b) * b;
};

function PriceSlider({
  isRange,
  value: v,
  min: sMin = 0,
  max: sMax = 0,
  onChange,
  ...rest
}: PriceSliderProps) {
  const { price, changePrice } = useContext(AppContext);

  const range = useMemo(() => {
    return {
      min: sMin <= STEP ? sMin : round(sMin, STEP),
      max:
        sMax <= STEP
          ? sMax
          : round(sMax % STEP === 0 ? sMax : sMax + STEP, STEP),
    };
  }, [sMin, sMax]);

  useEffect(() => {
    if (!isRange) {
      const newValue: [number, number] = [range.min, range.max];
      changePrice(newValue);
    }
  }, [isRange, range]);

  useEffect(() => {
    if (v) changePrice(v);
  }, [range]);

  useEffect(() => {
    if (isRange) {
      const { price: p, ...withoutPrice } = urlQueryString.get();
      urlQueryString.set({
        ...withoutPrice,
        price,
      });
    }
  }, [isRange, price]);

  return (
    <RangeSlider
      {...rest}
      {...range}
      step={STEP}
      value={price}
      onChange={(t: [number, number]) => changePrice(t)}
      onAfterChange={onChange}
    />
  );
}

export default PriceSlider;
